import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'

import { msalInstance } from '@/services/entraAuth'

// FORCE a http to https redirection, if env setting is set(ie https is on) - EWB
if (process.env.VUE_APP_USE_HTTPS == 'true') {
  if (location.protocol !== 'https:') {
    // console.info('redirecting!')
    location.replace(
      `https:${location.href.substring(location.protocol.length)}`
    )
  } else {
    // console.info('not redirecting...')
  }
}

Vue.prototype.$auth = msalInstance
Vue.config.productionTip = false
Vue.use(Vuex, msalInstance)

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
})

router.onReady(() => app.$mount('#app'))
